
import HeaderTitleContent from "../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import PageContent from "../../common/components/atom/PageContent/PageContent";
import SectionTitle from "../../common/components/atom/SectionTitle/SectionTitle";
import AddNewHardwareBtn from "../../features/hardwares/components/AddNewHardwareBtn/AddNewHardwareBtn";
import NewPayGo from "../../features/paygo/components/NewPayGo";
import NewStation from "../../features/stations/components/NewStation";
export default function HomePage() {
  return (
    <PageContent>
      <HeaderTitleContent>Tableau de Bord</HeaderTitleContent>
      <SectionTitle iconType={"admin"}>Actions</SectionTitle>
      <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
        <NewStation.AddNewStationBtn goToCreateNewStationMode/>
        <NewPayGo.NewPayGoBtn goToCreateNewPayGoMode/>
        <AddNewHardwareBtn goToCreateNewHardwareMode/>
      </div>
    </PageContent>
  );
}
